import { get, isEmpty } from 'lodash';
import { validateReduxForm } from 'common/form';
import { TrackService } from 'src/common/form/Interactions/components/TrackService';

const EDIT_TRACK_SERVICE_FORM = 'editServiceProvidedNote';
const fields = [
  'caseOptions[].id',
  'caseOptions[].selected',
  'caseOptions[].label',
  'caseOptionSelected',
  'provided_service.note',
  'provided_service.type',
  'provided_service.amount',
  'provided_service.unit',
  'provided_service.date',
  'interaction.is_note_private',
];

function mapStateToProps(state, ownProps = {}) {
  const { caseOptions } = ownProps;
  const isMyProviderSensitive = get(
    state,
    'globalState.currentProvider.group.sensitive',
    null,
  );
  const showNoteVisibility = ownProps.detailType === 'profile';

  return {
    initialValues: {
      caseOptions,
      interaction: ownProps.initialValues?.interaction,
      provided_service: ownProps.initialValues?.provided_service,
      ...ownProps.initialValues,
    },
    validateCases: !isEmpty(caseOptions),
    isMyProviderSensitive,
    showNoteVisibility,
  };
}

export default validateReduxForm(
  {
    form: EDIT_TRACK_SERVICE_FORM,
    destroyOnUnmount: true,
    fields,
  },
  mapStateToProps,
)(TrackService);
